const publicationSites = [
    {
        site: 'Scopus',
        link: 'https://www.scopus.com/authid/detail.uri?authorId=7004137693'
    },
    {
        site: 'Orcid',
        link: 'https://orcid.org/0000-0002-5550-7816'
    },
    {
        site: 'DBLP',
        link: 'https://dblp.org/pid/t/ErayTuzun.html'
    },
    {
        site: 'Google Scholar',
        link: 'https://scholar.google.com/citations?hl=en&user=D4jovncAAAAJ&view_op=list_works&sortby=pubdate'
    },
    {
        site: 'Semantic scholar',
        link: 'https://www.semanticscholar.org/author/Eray-T%C3%BCz%C3%BCn/13576179'
    },
    {
        site: 'ResearcherId',
        link: 'https://www.webofscience.com/wos/author/record/166276'
    },
]

export default publicationSites;